<template>
    <div
        class="z-image"
        :class="[
            {'z-image--background': background},
            {'z-image--border-radius': borderRadius}
        ]"
        :style="backgroundStyles"
        :alt="alt"
    >
        <img
            v-if="!background"
            :srcset="srcset"
            :src="src"
            class="z-image__img"
            :alt="alt"
            :width="width"
            :height="height"
        >

        <div
            v-if="overlay"
            class="z-image__overlay"
            :style="{background: overlay}"
        ></div>
    </div>
</template>

<script setup>
import {computed} from 'vue'

const props = defineProps({
    src: {
        type: String,
        required: true
    },
    srcset: {
        type: String,
    },
    overlay: {
        type: String,
        comment: 'Прокидывается кастомный rgba'
    },
    background: {
        type: Boolean,
        default: false
    },
    width: {
        type: String
    },
    height: {
        type: String
    },
    alt: {
        type: String
    },
    borderRadius: {
        type: Boolean,
        default: true
    },
    paddingTop: {
        type: String,
        comment: 'Задаем соотношение сторон для варианта, когда картинка background'
    }
})

const backgroundStyles = computed(() => {
    return {
        width: props.background ? `${props.width}px` : null,
        height: props.background ? `${props.height}px` : null,
        'background-image': props.background ? `url(${props.src})` : null,
        'padding-top': props.paddingTop ? `${props.paddingTop}%` : null
    }
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
